import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import blogImage from "../../../assets/blog.jpg";
import HomeHeaderService from "../../../services/HomeHeaderService";
import "./style.css";

const WhoWeAre = () => {
	const [video, setVideo] = useState("");
	const { t } = useTranslation();

	useEffect(() => {
		new HomeHeaderService().getList("whoWeAre").then((res) => {
			if (res.status === 200) {
				let response = res?.data?.data;
				if (!!response?.video) setVideo(response?.video);
			}
		});
	}, []);

	if (!video) {
		return;
	}
	return (
		<div className="WhoWeAre" id="who-we-are">
			<div className="container">
				<p className="title">{t("Who We Are")}</p>
				<video className="w-100" controls>
					<source src={video} type="video/mp4" />
					<source src={video} type="video/ogg" />
				</video>
			</div>
		</div>
	);
};
export default WhoWeAre;
